import { Buffer } from "buffer";
import { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import useAppNavigation from "../../hooks/useAppNavigation";
import { setEmailAndCodeForPasswordReset } from "../../lib/auth";
import LandingPageWrapper from "./LandingPageWrapper";
import SignInComponent from "./components/SignInComponent";

export default function SignInPage() {
  const navigate = useNavigate();
  const { navigateHome } = useAppNavigation();

  const [searchParams] = useSearchParams();
  const [showSignIn, setShowSignIn] = useState(false);

  const manageInvitationLink = "/manage-invitation";
  const resetPasswordLink = "/reset-password";
  const registerLink = "/register";

  useEffect(() => {
    const encodedData = searchParams.get("data");
    const encodedResetData = searchParams.get("resetData");
    // If user is directed from an email link with user and password queries auto login
    if (encodedData) {
      const decodedData = JSON.parse(atob(encodedData));
      navigate(manageInvitationLink, { state: decodedData });
    } else if (encodedResetData) {
      const decodedResetData = JSON.parse(
        Buffer.from(encodedResetData, "base64").toString(),
      );
      setEmailAndCodeForPasswordReset(
        decodedResetData.user,
        decodedResetData.code,
      );
      navigate(resetPasswordLink);
    } else {
      setShowSignIn(true);
    }
  }, [navigate, navigateHome, searchParams]);

  if (!showSignIn) return <></>;
  return (
    <LandingPageWrapper>
      <SignInComponent
        onSuccess={() => navigateHome()}
        onClickRegister={() => navigate(registerLink)}
        sx={{
          px: { xs: 1, lg: 3 },
          borderRadius: 10,
          overflow: "hidden",
        }}
      />
    </LandingPageWrapper>
  );
}
